<div class="categories-page">
    <div class="content">
        <!-- Mobile logos -->
        <div class="mobile-logos">
            <img src="../../../assets/logos/logo_proyecto_ayuntamiento.svg" alt="Logos del proyecto">
        </div>

        <!-- Search and Filters -->
        <div class="search-section">
            <div class="search-bar">
                <svg class="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="m21 21-4.35-4.35"></path>
                </svg>
                <input type="text" [placeholder]="'CATEGORIES_PAGE.SEARCH_PLACEHOLDER' | translate" [value]="searchQuery()"
                    (input)="updateSearchQuery($event)" />
            </div>

            <!-- Desktop filters -->
            <div class="category-filters">
                @for (category of categories; track category.id) {
                <button class="filter-btn" [class.active]="isCategorySelected(category.id)"
                    (click)="selectCategory(category.id)">
                    @if (category.icon) {
                    <img [src]="category.icon" [alt]="category.label | translate" class="filter-icon" width="20" height="20">
                    }
                    {{ category.label | translate }}
                </button>
                }
            </div>
        </div>

        <!-- Floating Mobile filter button (RIGHT SIDE) -->
        <button class="mobile-filter-fab" [class.hidden]="sidebarService.isSidebarOpen()"
            (click)="toggleMobileFilters()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                @if (isMobileFiltersOpen()) {
                <polyline points="9 18 15 12 9 6"></polyline>
                } @else {
                <polyline points="15 18 9 12 15 6"></polyline>
                }
            </svg>
        </button>

        <!-- Mobile filter sidebar -->
        <div class="mobile-filter-sidebar" [class.open]="isMobileFiltersOpen()">
            <div class="mobile-filter-header">
                <h3>{{'CATEGORIES_PAGE.FILTERS' | translate}}</h3>
                <button class="close-btn" (click)="closeMobileFilters()" type="button">✕</button>
            </div>

            <!-- Search section -->
            <div class="mobile-sidebar-section">
                <label class="section-label">{{'CATEGORIES_PAGE.SEARCH' | translate}}</label>
                <div class="mobile-sidebar-search">
                    <svg class="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2">
                        <circle cx="11" cy="11" r="8"></circle>
                        <path d="m21 21-4.35-4.35"></path>
                    </svg>
                    <input type="text" [placeholder]="'CATEGORIES_PAGE.SEARCH_PLACEHOLDER_MOBILE' | translate" [value]="searchQuery()"
                        (input)="updateSearchQuery($event)" />
                </div>
            </div>

            <!-- Categories section -->
            <div class="mobile-sidebar-section">
                <label class="section-label">{{'CATEGORIES_PAGE.CATEGORIES' | translate}}</label>
                <div class="mobile-filter-content">
                    @for (category of categories; track category.id) {
                    <button class="mobile-filter-item" [class.active]="isCategorySelected(category.id)"
                        (click)="selectCategory(category.id)">
                        @if (category.icon) {
                        <img [src]="category.icon" [alt]="category.label | translate" class="filter-icon" width="20" height="20">
                        }
                        {{ category.label | translate }}
                    </button>
                    }
                </div>
            </div>

        </div>

        <!-- Overlay -->
        @if (isMobileFiltersOpen()) {
        <div class="mobile-filter-overlay" (click)="closeMobileFilters()"></div>
        }

        <!-- Cards Grid -->
        <div class="cards-grid">
            @for (card of filteredCards(); track card.OBJECTID) {
            <app-card [denominacion]="card.denominacion" [categoria]="card.categoria" [OBJECTID]="card.OBJECTID"
                [image]="'/assets/images/cards/' + card.OBJECTID + '.jpg'"
                [routerLink]="isAccommodation(card.categoria) ? [paths.ACCOMMODATIONS] : [paths.SHEET, card.OBJECTID]">
            </app-card>
            }
        </div>
    </div>

</div>